import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '@store/types';
import { updateUserPicture } from '@reducers/user';
import {
  refreshForceRetrieveFromSource,
  removeImageDocumentFromDict,
  setNotSubmittedDeletedImage,
} from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';
import { clearMachineImageByDocumentId } from '@reducers/machines';
import { clearSoftDeletedMessagesByKey, selectMessagesByKey, softDeleteMessagesByKey } from '@reducers/v2/messagesBus/messagesBus.slice';
import { ImageDocumentMessageType } from '@reducers/v2/messagesBus/types';

interface RemoveImageDocumentMessageHandlerPayload {
  documentId: number;
  local?: boolean;
}

export const removeImageDocumentMessageHandler = createAsyncThunk<void, RemoveImageDocumentMessageHandlerPayload>(
  'imageHandlingV2/removeImageDocumentMessageHandler',
  ({ documentId, local }, { dispatch, getState }) => {
    const rootStore = getState() as RootState;
    const userStore = rootStore.user;

    refreshForceRetrieveFromSource();

    if (userStore?.userInfo?.userPicture?.documentId === documentId) {
      dispatch(updateUserPicture(null));
    }

    if (local) {
      const messagesToSnapshot = selectMessagesByKey(rootStore, documentId).filter(
        (message) => message.messageType !== ImageDocumentMessageType.IMAGE_DELETED
      );
      dispatch(softDeleteMessagesByKey({ key: documentId, messages: messagesToSnapshot }));
    } else {
      dispatch(setNotSubmittedDeletedImage(null));
      dispatch(clearSoftDeletedMessagesByKey(documentId));
    }
    dispatch(clearMachineImageByDocumentId({ documentId }));
    dispatch(removeImageDocumentFromDict({ documentId }));
  }
);
